import React from 'react';
import { Link } from 'react-router-dom';

interface GuideCtaProps {
  to: string; // inscription menant à l'outil (ex. /signup?start=budget)
  title: string;
  text: string;
  label: string;
}

// Mention répétée sous chaque appel à l'action : tout est gratuit, pas seulement l'inscription.
export const FreeNote: React.FC = () => (
  <p className="mg-cta-free">100 % gratuit : toutes les fonctionnalités, sans abonnement ni carte bancaire.</p>
);

// Encadré d'appel à l'action des articles du site vitrine (vers l'outil de l'app),
// toujours avec la mention « 100 % gratuit » : aucune ambiguïté sur le prix.
const GuideCta: React.FC<GuideCtaProps> = ({ to, title, text, label }) => (
  <aside className="mg-cta-box">
    <div>
      <p className="mg-cta-title">{title}</p>
      <p>{text}</p>
      <FreeNote />
    </div>
    <Link to={to} className="mkt-btn primary">
      {label}
    </Link>
  </aside>
);

export default GuideCta;
